import { legalPagesEs } from "./legalContentEs";
// AUR — The Mirror of the Mind
// Legal & Customer Information Content
// Source: Legal Content Master v1.1 — Confirmed Owner Decisions
// Implemented per Packet 0021
//
// OMITTED GATES (not published per Packet 0021 instructions):
// Section 1.18 Governing Law — legal review gate.
// Section 2.6 Cookies/Analytics — production verification gate.
// Section 2.7 specific retention periods — production/legal review gate.
// Section 2.9 full children's-privacy statement — legal review gate (confirmed fact only published).
// Section 2.10 state-specific/international disclosures — legal review gate.
// Registration/trademark numbers — confirmed omission per Master v1.1.
// Business hours — not published per Master v1.1.
//
// content item types: "paragraph" | "sectionHeading"

export const legalPages = {
  terms: {
    slug: "terms",
    title: "Terms of Use / Terms of Sale",
    effectiveDate: "Effective upon publication.",
    content: [
      {
        type: "paragraph",
        text: "Welcome to AUR \u2014 The Mirror of the Mind (\u201cAUR,\u201d \u201cwe,\u201d \u201cus,\u201d or \u201cour\u201d). These Terms govern use of the Website and purchases of digital products offered through it, including AUR \u2014 The Mirror of the Mind (the \u201cProduct\u201d).",
      },
      {
        type: "paragraph",
        text: "By using the Website, placing an order, or purchasing the Product, you agree to these Terms. If you do not agree, do not use the Website or purchase the Product.",
      },
      { type: "sectionHeading", text: "1.1 Eligibility" },
      {
        type: "paragraph",
        text: "You must be legally capable of entering a binding agreement under applicable law. No separate minimum age restriction is imposed by AUR for the Product.",
      },
      { type: "sectionHeading", text: "1.2 Product" },
      {
        type: "paragraph",
        text: "The Product is a digital publication. The Website will identify its edition, format, price, and principal characteristics before purchase. The book is a literary and educational work and does not promise a particular medical, psychological, financial, legal, spiritual, professional, or other outcome.",
      },
      { type: "sectionHeading", text: "1.3 Orders" },
      {
        type: "paragraph",
        text: "Submitting an order is a request to purchase. An order is accepted when payment is successfully processed and the purchase is confirmed. AUR may correct obvious pricing, description, availability, or technical errors and cancel an order where permitted by law.",
      },
      { type: "sectionHeading", text: "1.4 Price and Taxes" },
      {
        type: "paragraph",
        text: "The applicable purchase price and any applicable taxes or other charges will be presented before payment. The final checkout amount is the amount authorized for the transaction, subject to lawful adjustments disclosed at checkout.",
      },
      { type: "sectionHeading", text: "1.5 Stripe Payment Processing" },
      {
        type: "paragraph",
        text: "Payments are processed through Stripe, Inc. and/or the applicable Stripe payment-processing entity. Depending on the implementation, customers may enter payment details on a Stripe-hosted Checkout page or through a Stripe-powered checkout interface. AUR does not ask customers to send full payment-card numbers, card security codes, banking credentials, or passwords by email. Stripe may process transaction information under its own privacy practices.",
      },
      { type: "sectionHeading", text: "1.6 Digital Delivery" },
      {
        type: "paragraph",
        text: "After successful payment, authorized customer access to the Product is provided through the Website\u2019s verified digital-delivery/access flow. Delivery or access instructions may appear on the confirmation page and/or be associated with the email address supplied at checkout. If a successful purchase does not produce access, contact AURMirror@gmail.com.",
      },
      { type: "sectionHeading", text: "1.7 Refunds and Cancellations" },
      {
        type: "paragraph",
        text: "Completed digital-product sales are final and non-refundable except where a refund is required by applicable law or expressly approved by AUR. If a technical problem prevents access, contact AURMirror@gmail.com so we can investigate and, where appropriate, restore access, provide a replacement copy, or issue a refund.",
      },
      { type: "sectionHeading", text: "1.8 Payment Disputes / Chargebacks" },
      {
        type: "paragraph",
        text: "Customers should contact AUR first about incorrect charges or failed delivery. Nothing in these Terms removes non-waivable rights under applicable law or payment-network rules.",
      },
      { type: "sectionHeading", text: "1.9 Purchaser License" },
      {
        type: "paragraph",
        text: "Purchase grants a limited, personal, non-exclusive, non-transferable license to access and use the purchased copy for lawful personal use. Unless expressly authorized, purchasers may not resell, sublicense, rent, commercially distribute, upload publicly, reproduce the complete book, remove proprietary notices, or redistribute substantial portions.",
      },
      { type: "sectionHeading", text: "1.10 Limited Quotation" },
      {
        type: "paragraph",
        text: "Limited quotation may be permitted by applicable copyright law for criticism, commentary, review, scholarship, research, or similar lawful purposes. This does not authorize reproduction or distribution of the complete book or substantial portions.",
      },
      { type: "sectionHeading", text: "1.11 Intellectual Property" },
      {
        type: "paragraph",
        text: "The Website, book text, cover art, interior art, photographs, logos, AUR marks, graphics, page designs, and other original materials are protected by applicable intellectual-property laws. AUR and its licensors retain rights not expressly granted.",
      },
      { type: "sectionHeading", text: "1.12 Prohibited Website Conduct" },
      {
        type: "paragraph",
        text: "You may not interfere with Website security or operation, attempt unauthorized access, introduce malicious code, unlawfully scrape protected content, use the Website for unlawful purposes, or misrepresent an affiliation with AUR.",
      },
      { type: "sectionHeading", text: "1.13 Third-Party Services" },
      {
        type: "paragraph",
        text: "The Website may use third-party providers for payment processing, hosting, email, analytics, security, customer support, or related functions. Those providers may have their own terms and privacy policies.",
      },
      { type: "sectionHeading", text: "1.14 Availability" },
      {
        type: "paragraph",
        text: "AUR seeks reliable access but does not guarantee uninterrupted or error-free Website availability. If a paid Product becomes inaccessible because of a technical problem caused by AUR, AUR will make reasonable efforts to restore access or provide an appropriate remedy consistent with the refund policy and applicable law.",
      },
      { type: "sectionHeading", text: "1.15 Warranties and Results" },
      {
        type: "paragraph",
        text: "To the maximum extent permitted by law, the Website and Product are provided on an \u201cas available\u201d basis. AUR does not guarantee particular results from reading or using the book. Rights and warranties that cannot legally be excluded remain unaffected.",
      },
      { type: "sectionHeading", text: "1.16 Limitation of Liability" },
      {
        type: "paragraph",
        text: "To the maximum extent permitted by applicable law, AUR will not be liable for indirect, incidental, special, consequential, exemplary, or punitive damages arising from Website or Product use. To the extent permitted by law, total liability relating to a purchase will not exceed the amount actually paid for the Product giving rise to the claim. This does not limit liability that cannot legally be limited.",
      },
      { type: "sectionHeading", text: "1.17 Changes" },
      {
        type: "paragraph",
        text: "AUR may update these Terms. The current version will be posted with a revised effective or last-updated date.",
      },
      // 1.18 Governing Law: omitted — legal review gate per Packet 0021.
      { type: "sectionHeading", text: "1.19 Contact" },
      { type: "paragraph", text: "AUR \u2014 The Mirror of the Mind" },
      { type: "paragraph", text: "AURMirror@gmail.com" },
      { type: "paragraph", text: "8750 West Rancho Drive, Glendale, Arizona 85305" },
    ],
  },

  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    effectiveDate: "Effective upon publication.",
    content: [
      {
        type: "paragraph",
        text: "AUR \u2014 The Mirror of the Mind (\u201cAUR,\u201d \u201cwe,\u201d \u201cus,\u201d or \u201cour\u201d) respects your privacy. This Privacy Policy explains information that may be collected through the Website, how it may be used, when it may be shared, and available choices.",
      },
      { type: "sectionHeading", text: "2.1 Information We May Collect" },
      {
        type: "paragraph",
        text: "Depending on use of the Website, AUR may collect name, email address, purchase/order information, information needed for digital delivery, support communications, voluntarily submitted information, technical/device information, IP address, Website-usage information, cookie information where used, and transaction information received from payment providers.",
      },
      { type: "sectionHeading", text: "2.2 Payment Information and Stripe" },
      {
        type: "paragraph",
        text: "Payments may be processed by Stripe. Where Stripe-hosted or Stripe-powered checkout is used, AUR is not intended to receive or store full payment-card numbers. Stripe may process transaction data depending on the transaction and configuration.",
      },
      { type: "sectionHeading", text: "2.3 Uses" },
      {
        type: "paragraph",
        text: "AUR may use information to process purchases, deliver Products, provide support, maintain accounting/tax records, prevent fraud and abuse, secure and operate the Website, improve services where analytics are enabled, comply with law, and send service-related purchase or security communications.",
      },
      { type: "sectionHeading", text: "2.4 Sharing" },
      {
        type: "paragraph",
        text: "AUR may share information with service providers that help operate the business, including payment processors, hosting providers, email providers, analytics providers, security providers, support providers, and professional advisers. Information may also be disclosed when reasonably necessary to comply with law, legal process, protect rights or safety, prevent fraud, or address security incidents.",
      },
      { type: "sectionHeading", text: "2.5 Third-Party Privacy Practices" },
      {
        type: "paragraph",
        text: "Stripe and other third-party providers may process information under their own policies. Customers should review those policies where appropriate.",
      },
      // 2.6 Cookies/Analytics: omitted — production verification gate per Packet 0021.
      { type: "sectionHeading", text: "2.7 Retention" },
      {
        type: "paragraph",
        text: "AUR retains information as reasonably necessary for fulfillment, support, accounting, tax, dispute resolution, fraud prevention, security, and legal obligations.",
      },
      // 2.7 specific retention periods: omitted — production/legal review gate per Packet 0021.
      { type: "sectionHeading", text: "2.8 Security" },
      {
        type: "paragraph",
        text: "AUR uses reasonable administrative, technical, and organizational measures designed to protect information. No system can be guaranteed completely secure. Customers should not email passwords, full card numbers, security codes, or unnecessary sensitive credentials.",
      },
      { type: "sectionHeading", text: "2.9 Children\u2019s Privacy" },
      {
        type: "paragraph",
        text: "No separate age restriction is imposed by AUR for the Product.",
      },
      { type: "sectionHeading", text: "2.10 Privacy Rights" },
      {
        type: "paragraph",
        text: "Depending on location and applicable law, individuals may have rights concerning personal information, including access, correction, deletion, copies, restriction, objection, or other controls. Requests may be sent to AURMirror@gmail.com. AUR may verify requests and may retain information where required or permitted by law.",
      },
      // 2.10 state-specific/international disclosures: omitted — legal review gate per Packet 0021.
      { type: "sectionHeading", text: "2.11 Marketing Email" },
      {
        type: "paragraph",
        text: "Transactional messages may be sent when necessary to complete or support a purchase. Optional marketing communications should include an appropriate unsubscribe mechanism and comply with applicable law.",
      },
      { type: "sectionHeading", text: "2.12 Changes" },
      {
        type: "paragraph",
        text: "AUR may update this Policy and will post the updated version with a revised date.",
      },
      { type: "sectionHeading", text: "2.13 Contact" },
      { type: "paragraph", text: "AURMirror@gmail.com" },
      { type: "paragraph", text: "8750 West Rancho Drive, Glendale, Arizona 85305" },
    ],
  },

  "digital-product-information": {
    slug: "digital-product-information",
    title: "Digital Product Information",
    effectiveDate: "Effective upon publication.",
    content: [
      { type: "paragraph", text: "Product: AUR \u2014 The Mirror of the Mind" },
      { type: "paragraph", text: "Edition/format: Protected digital-book edition." },
      { type: "paragraph", text: "Price: $22.22 USD, one-time purchase." },
      {
        type: "paragraph",
        text: "What the customer receives: Authorized protected access to the digital edition of AUR \u2014 The Mirror of the Mind through the Website's protected digital reader.",
      },
      {
        type: "paragraph",
        text: "Delivery/access: After successful payment, digital access is provided through the Website\u2019s authorized digital-delivery/access mechanism. Customer-facing instructions are provided through the purchase/confirmation flow.",
      },
      {
        type: "paragraph",
        text: "If access does not work: Contact AURMirror@gmail.com with the purchase email, approximate purchase date, receipt/order information if available, and a description of the problem.",
      },
      {
        type: "paragraph",
        text: "Refunds: Completed digital-product sales are final and non-refundable except where a refund is required by applicable law or expressly approved by AUR. If a technical problem prevents access, contact AURMirror@gmail.com so AUR can investigate and, where appropriate, restore access, provide a replacement copy, or issue a refund.",
      },
      {
        type: "paragraph",
        text: "Personal-use license: The purchase grants the limited personal-use rights described in the Terms of Use / Terms of Sale.",
      },
      {
        type: "paragraph",
        text: "Payment: Payment is processed through the authorized Stripe checkout flow. Customers should never send full payment-card information or security codes to AUR by email.",
      },
      { type: "paragraph", text: "Support: AURMirror@gmail.com" },
    ],
  },

  copyright: {
    slug: "copyright",
    title: "Copyright / Intellectual Property",
    effectiveDate: "Effective upon publication.",
    content: [
      {
        type: "paragraph",
        text: "Copyright \u00a9 2026 Lamarcus D. Walton, Sr. All rights reserved.",
      },
      { type: "paragraph", text: "AUR \u2014 The Mirror of the Mind" },
      {
        type: "paragraph",
        text: "The book AUR \u2014 The Mirror of the Mind, including its text, structure, original expression, cover and interior artwork, photographs, graphics, logos, visual identity, and associated original materials, is protected by applicable copyright and other intellectual-property laws.",
      },
      {
        type: "paragraph",
        text: "Except where permitted by law or expressly authorized in writing, no part of the publication may be reproduced, distributed, publicly displayed, transmitted, republished, sold, licensed, or incorporated into another commercial work.",
      },
      {
        type: "paragraph",
        text: "Limited quotation may be permitted for commentary, criticism, review, scholarship, research, or similar lawful purposes under applicable law. No permission is granted to reproduce the complete book or substantial portions.",
      },
      {
        type: "paragraph",
        text: "AUR, AUR \u2014 The Mirror of the Mind, the public website domain, and associated logos or marks may be protected identifiers of their owner(s), as applicable. No trademark or other license is granted merely by purchasing or viewing the Product.",
      },
      { type: "paragraph", text: "Permissions: AURMirror@gmail.com" },
      { type: "paragraph", text: "Copyright owner: Lamarcus D. Walton, Sr." },
      { type: "paragraph", text: "Copyright year: 2026" },
    ],
  },

  contact: {
    slug: "contact",
    title: "Contact / Support",
    effectiveDate: "Effective upon publication.",
    content: [
      { type: "paragraph", text: "AUR \u2014 The Mirror of the Mind" },
      { type: "paragraph", text: "Customer Support: AURMirror@gmail.com" },
      {
        type: "paragraph",
        text: "For purchase or delivery assistance, include the name used for purchase, checkout email, approximate purchase date, order/receipt number if available, and a description of the issue.",
      },
      {
        type: "paragraph",
        text: "Do not email full credit-card numbers, card security codes, passwords, banking credentials, government identification numbers, or other unnecessary sensitive information.",
      },
      { type: "paragraph", text: "Purchase assistance \u2014 AURMirror@gmail.com" },
      { type: "paragraph", text: "Digital delivery/access \u2014 AURMirror@gmail.com" },
      { type: "paragraph", text: "Refund requests \u2014 AURMirror@gmail.com" },
      { type: "paragraph", text: "Privacy requests \u2014 AURMirror@gmail.com" },
      { type: "paragraph", text: "Copyright/permissions \u2014 AURMirror@gmail.com" },
      { type: "paragraph", text: "General questions \u2014 AURMirror@gmail.com" },
      { type: "paragraph", text: "Expected response time: 1\u20133 business days" },
      {
        type: "paragraph",
        text: "Mailing/notice address: 8750 West Rancho Drive, Glendale, Arizona 85305",
      },
      { type: "paragraph", text: "Telephone: Email support only." },
      // Business hours: not published per Master v1.1.
    ],
  },
};

export const legalOrder = [
  "digital-product-information",
  "terms",
  "privacy",
  "copyright",
  "contact",
];

export function getLegalPages(language) {
  return language === "es" ? legalPagesEs : legalPages;
}
